import { CourseData } from "@/interface/overview";
import { AssignmentItem } from "@/interface/viewClass";
import { dataCourseDetail } from "@/services/View Class/fetchCourseDetail";
import { mappedData } from "@/services/View Class/fetchHIstory";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const useViewClass = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const [user, setUser] = useState<any>(null);
  const [course, setCourse] = useState<CourseData | null>(null);
  const [assignments, setAssignments] = useState<AssignmentItem[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const defaultImage = "/buku2.png";

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (storedUser && token) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);

      fetchCourseDetail(parsedUser.id, token);
      fetchHistory(parsedUser.id);
    } else {
      setIsLoading(false);
    }
  }, [id]);

  const fetchCourseDetail = async (userId: number, token: string) => {
    try {
      await dataCourseDetail(userId, token, id ?? "", setCourse);
    } catch (err) {
      console.error("Gagal mengambil detail kursus:", err);
    }
  };

  const fetchHistory = async (userId: number) => {
    try {
      const data = await mappedData(userId);
      setAssignments(data);
    } catch (err) {
      console.error("Gagal mengambil data history:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to log out?")) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      navigate("/auth/Login");
    }
  };

  const handleSidebarClick = (menuName: string) => {
    navigate("/user/dashboard");
  };

  return {
    isSidebarOpen,
    isCollapsed,
    user,
    course,
    assignments,
    isLoading,
    defaultImage,
    id,
    navigate,
    handleLogout,
    handleSidebarClick,
    setIsSidebarOpen,
    setIsCollapsed,
    setIsLoading,
  };
};
